"use client"

import * as React from "react"
import { Button } from "./button"
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "./dialog"

interface ConfirmationDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  title: string
  description: string
  onYes: () => void
  onNo: () => void
  onCancel: () => void
  yesText?: string
  noText?: string
  cancelText?: string
}

export function ConfirmationDialog({
  open,
  onOpenChange,
  title,
  description,
  onYes,
  onNo,
  onCancel,
  yesText = "Yes",
  noText = "No",
  cancelText = "Cancel"
}: ConfirmationDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>
            {description}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex gap-2">
          <Button
            variant="outline"
            onClick={onCancel}
          >
            {cancelText}
          </Button>
          <Button
            variant="outline"
            onClick={onNo}
          >
            {noText}
          </Button>
          <Button
            onClick={onYes}
            className="bg-green-600 hover:bg-green-700"
          >
            {yesText}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}





































